module.exports = __webpack_public_path__ + "img/bg-login-s.dbb17aa5.png";